import {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
    fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

// const headers = {
//     'Content-Type': 'application/json',
// };

const issQuery = (url: string, headers: { [key: string]: string }) => {
    const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
        args,
        WebApi,
        extraOptions
    ) => {
        const rawBaseQuery = fetchBaseQuery({ baseUrl: url, headers });
        const result = await rawBaseQuery(args, WebApi, extraOptions);
        if (result.error) {
            return result;
        }

        if (result.data) {
            return result['data'] as any;
        }
    };
    return dynamicBaseQuery;
};

export default issQuery;